import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLead } from './context/LeadProvider';
import LeadFilterStatus from './LeadsToolBar/LeadFilterStatus';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import { ReportDate, useNeedPay } from 'modules/admin';
import SolarIcon from 'components/icons/SolarIcon';
import EToolTip from 'components/others/EToolTip';

interface LeadToolBarProps {
    setShowNewLead: (show: boolean) => void;
}

const LeadToolBar = ({ setShowNewLead }: LeadToolBarProps) => {
    const { t } = useTranslation(['Leads', 'common']);
    const {
        triggerListReset,
        triggerListRefresh,
        leadsDateFilter,
        setLeadsDateFilter,
        showDashboard,
        setShowDashboard,
        showTitle,
        showSource,
        showCreated,
        showAccess,
        showDate,
        toggleListColumn,
    } = useLead();
    const { needPay } = useNeedPay();

    return (
        <div className="mb-3" style={{ minWidth: '100px' }}>
            <div className="page-toolbar-actions">
                <Button
                    className="fs-14"
                    size="sm"
                    variant="success"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        if (needPay()) return;
                        setShowNewLead(true);
                    }}
                >
                    <SolarIcon name="plus" className="fs-14 p-0" />
                    <span className="d-none d-sm-inline ms-1">{t('toolAddLead')}</span>
                </Button>

                <EToolTip title={showDashboard ? t('toolHideDashboard') : t('toolShowDashboard')}>
                    <span className="d-inline-block">
                        <Button
                            className="fs-14 px-2 toolbar-icon-btn"
                            size="sm"
                            variant={showDashboard ? 'info' : 'secondary'}
                            onClick={(e) => {
                                e.currentTarget.blur();
                                setShowDashboard((prev) => !prev);
                            }}
                        >
                            <SolarIcon name="columns-gap" className="fs-14 p-0" />
                        </Button>
                    </span>
                </EToolTip>

                <ReportDate
                    setDates={(value) => {
                        setLeadsDateFilter((prev) => ({
                            ...prev,
                            dates: typeof value === 'function' ? value(prev.dates) : value,
                        }));
                    }}
                    initialFilter={leadsDateFilter}
                    onFilterChange={setLeadsDateFilter}
                    showOff
                    hideTextInTitle
                    alertOnFilterSet
                />

                <ListToolBarActions
                    filters={<LeadFilterStatus />}
                    onReset={triggerListReset}
                    onRefresh={triggerListRefresh}
                    columns={{
                        items: [
                            { id: 'title', label: t('fields.title'), visible: showTitle },
                            { id: 'source', label: t('fields.source'), visible: showSource },
                            { id: 'created', label: t('fields.created'), visible: showCreated },
                            { id: 'access', label: t('fields.access'), visible: showAccess },
                            { id: 'date', label: t('fields.update'), visible: showDate },
                        ],
                        onToggle: (id) => toggleListColumn(id as 'title' | 'source' | 'created' | 'access' | 'date'),
                    }}
                />
            </div>
        </div>
    );
};

export default LeadToolBar;
